import React, { useEffect } from 'react';
import Page from '../page';
import Loader from '../loader/loader';
import { useGetManufacturingQuery } from '../../store/slices/apiSlice/manufacturing-api';
import { useUpdateProjectMutation } from '../../store/slices/apiSlice/project-api-slice';
import { toastSuccess } from '../../utilities/toast';
import { handleBackendError } from '../../utilities/errorHandling';
import ManufacturingTable from '../manufacturingTable';

function ManufacturingDashboard() {
    const {
        data: manufacturingData,
        error,
        isLoading,
    } = useGetManufacturingQuery();
    const [updateProject, updateProjectResult] = useUpdateProjectMutation();

    useEffect(() => {
        if (error) {
            handleBackendError('Get Manufacturing Data', error);
        }
    }, [error]);

    useEffect(() => {
        const { isError, status, isSuccess } = updateProjectResult;
        if (isError) {
            handleBackendError('Update Mfg Project', updateProjectResult);
        } else if (updateProjectResult?.data?.result === 'Error') {
            handleBackendError(
                'Update Mfg Project',
                updateProjectResult?.data?.message
            );
        } else if (status === 'fulfilled' && isSuccess) {
            toastSuccess('Project ManufacturingUpdated');
        }
    }, [updateProjectResult]);

    const handleUpdate = (projectId, field, value) => {
        let projectUpdates = { ProjectManufacturing: {} };
        projectUpdates.ProjectManufacturing[field] = value;
        updateProject({ aroId: projectId, projectUpdates });
    };

    return (
        <Page>
            <div className="ps-0 ps-md-4 pe-2 pe-sm-0 pe-xs-0">
                <h1 className="mt-2">Manufacturing Dashboard</h1>
                {isLoading ? (
                    <Loader />
                ) : error ? null : (
                    <ManufacturingTable
                        projects={manufacturingData?.projects}
                        onUpdate={handleUpdate}
                    />
                )}
            </div>
        </Page>
    );
}

export default ManufacturingDashboard;
